// extracted by mini-css-extract-plugin
export default {"main":"PartnersSection_main__58e0V","headerText":"PartnersSection_headerText__bZkuA","eachSlide":"PartnersSection_eachSlide__mPQ4V"};